/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MapObject
 */
export interface MapObject {
    /**
     * 
     * @type {object}
     * @memberof MapObject
     */
    key?: object;
}

/**
 * Check if a given object implements the MapObject interface.
 */
export function instanceOfMapObject(value: object): value is MapObject {
    return true;
}

export function MapObjectFromJSON(json: any): MapObject {
    return MapObjectFromJSONTyped(json, false);
}

export function MapObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): MapObject {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
    };
}

export function MapObjectToJSON(json: any): MapObject {
    return MapObjectToJSONTyped(json, false);
}

export function MapObjectToJSONTyped(value?: MapObject | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
    };
}

